import { render, staticRenderFns } from "./FeHyggeKidz.vue?vue&type=template&id=a8521946&"
import script from "./FeHyggeKidz.vue?vue&type=script&lang=js&"
export * from "./FeHyggeKidz.vue?vue&type=script&lang=js&"
import style0 from "./FeHyggeKidz.vue?vue&type=style&index=0&id=a8521946&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports